<template>
  <div
    v-if="loadedPage"
    class="entity-progress"
    :class="{
      'progress--issue': hasIssue,
    }">
    <div
      v-for="(check, index) in cashbackProgress"
      :key="index"
      class="progress-check"
      :class="{
        'progress--with-titles': titles,
      }"
      @click="$emit('clicked', check)">
      <span v-if="titles" class="check-label">{{ check.label }}</span>
      <iconComponent
        :symbol="check.symbol"
        :stroke="getIconColor(check)"
        :fill="getIconColor(check)"/>
      <span class="tooltip">{{ getTooltip(check) }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: "CashbackProgress",
  props: {
    admin: {
      type: Boolean,
      default: false,
    },
    titles: {
      type: Boolean,
      default: false,
    },
    cashback: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    userType() {
      return this.admin ? 'Admin' : 'Company';
    },
    routesName() {
      return this.admin ? 'Admin' : 'Partner';
    },
    hasIssue() {
      return ['152', '159', '511', '521', '711', '721', '911', '921'].includes(this.cashback.responsecode);
    },
    cashbackProgress() {
      /*
      const registered = ['105', '107', '150'].includes(responsecode);

      {
        label: 'Received',
        tooltip: 'Cashback request received',
        symbol: 'medal',
        status: responsecode === '101',
        n: 0,
      },
      {
        label: 'Registered',
        tooltip: registered ? responsetext : 'Cashback registered',
        symbol: 'medal',
        status: registered,
        n: 1,
      },
      {
        label: 'Payout Pending',
        tooltip: 'Payout is being processed',
        symbol: 'wallet',
        status: responsecode === '111',
        n: 3,
      },
      */
      const responsecode = this.cashback.responsecode;

      const steps = [
        /*{
          label: 'Error',
          tooltip: this.hasIssue ? responsetext : 'No issue',
          symbol: 'errorCircle',
          status: this.hasIssue,
        },*/
        {
          label: 'Approved',
          tooltip: 'Approved for payout',
          symbol: 'checkmark',
          status: this.cashback.success === true || responsecode === '111',
        },
        {
          label: 'Paid',
          tooltip: 'Cashback paid out',
          symbol: 'wallet',
          status: this.cashback.done === true || responsecode === '000',
        },
      ];

      return steps;
    },
  },
  data() {
    return {
      loadedPage: true,
      detailedInfoModal: false,
    };
  },
  watch: {
  },
  methods: {
    getIconColor({ status, n }) {

      if (status) {
        if (this.hasIssue) {
          return 'red';
        }
        return 'green';
      } else {
        return 'grey';
      }
    },
    getTooltip({ tooltip, status, n }) {
      let message = '';
      const responsetext = this.cashback.responsetext;

      if (this.hasIssue) {
        message = responsetext;
      } else if (status) {
        message = 'Completed';
      }

      message += `${message ? ': ': ''}${tooltip}`;
      return message;
    },
  }
};
</script>

<style lang="scss" scoped>
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./CashbackProgress.scss";
</style>
